import { useMyOrganizations } from '@ilteducation/my-account';
import { SlimOrganization } from '@ilteducation/my-account-types';
import { ref, computed } from 'vue';

/** The uid the placeholder organization below carries while no organization is selected. */
export const NO_ORGANIZATION_SELECTED_UID = '';

const defaultOrg: SlimOrganization = {
  active: true,
  parent: null,
  name: '',
  type: 'school',
  qrCodeLoginEnabled: false,
  role: 'student',
  secureAuthEnabled: false,
  userManagementDisabled: true,
  uid: NO_ORGANIZATION_SELECTED_UID,
  settings: {
    accessRestrictionLevel: {
      storedValue: undefined,
      effectiveValue: 'school',
      inheritance: 'overridable',
    },
  },
};

const organization = ref<SlimOrganization>(defaultOrg);
export const useCurrentOrganization = () => {
  const { organizations: organizationsResponse } = useMyOrganizations(true);
  const organizations = computed(() =>
    organizationsResponse.value.data.filter((org) => org.active).filter((org) => !org.userManagementDisabled),
  );

  const setCurrentOrganization = (org: SlimOrganization | null) => {
    organization.value = org ?? defaultOrg;
  };

  return {
    organization,
    organizations,
    setCurrentOrganization,
  };
};
